import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=4e18f15e&scoped=true&"
import script from "./Load.vue?vue&type=script&lang=js&"
export * from "./Load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e18f15e",
  null
  
)

export default component.exports